module.exports = __webpack_public_path__ + "img/discountStatus4.119b367b.svg";